export function copyToClipboard(elem) {
  // var e
  let target
  const targetId = '_hiddenCopyText_'
  const isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA'
  let origSelectionStart = void 0
  let origSelectionEnd = void 0
  if (isInput) {
    target = elem
    origSelectionStart = elem.selectionStart
    origSelectionEnd = elem.selectionEnd
  } else {
    target = document.getElementById(targetId)
    if (!target) {
      target = document.createElement('textarea')
      target.style.position = 'absolute'
      target.style.left = '-9999px'
      target.style.top = '0'
      target.id = targetId
      document.body.appendChild(target)
    }

    target.textContent = elem.textContent
  }

  const currentFocus = document.activeElement
  target.focus()
  target.setSelectionRange(0, target.value.length)
  let succeed = void 0
  try {
    succeed = document.execCommand('copy')
  } catch (_error) {
    console.info(`_error: ${_error}`)
    succeed = false
  }
  if (currentFocus && typeof currentFocus.focus === 'function') {
    currentFocus.focus()
  }
  if (isInput) {
    console.debug('isInput')
    elem.setSelectionRange(origSelectionStart, origSelectionEnd)
  } else {
    target.textContent = ''
  }
  return succeed
}

export default copyToClipboard
window.copyToClipboard = copyToClipboard